// Resolve's web-session configuration (the shared package in src/shared/session).
// Imported by the API helpers and <SessionProvider>, so it is configured before
// any request or render. It imports the config module only (as admiral does),
// so the contexts that import it don't load the token verifier.

import { configureSession } from "./shared/session/config";

export const sessionConfig = configureSession({
	app: "resolve",
	apiUrl: process.env.REACT_APP_API_URL || "",
	admiralUrl: process.env.REACT_APP_ADMIRAL_APP || "",
	domainName: process.env.REACT_APP_DOMAIN_NAME || "",
	userPoolId: process.env.REACT_APP_USERPOOL_ID || "",
	clientId: process.env.REACT_APP_CLIENT_ID || "",
	// optional (localhost); defaults to https://app.<REACT_APP_DOMAIN_NAME>
	sessionApiUrl: process.env.REACT_APP_SESSION_API_URL || undefined,
});
